module.exports = (name) => {
  // Sheets name not alow * ? : \ / [ ]
  return name.replace(/[*?:\/\\[\]]/g, "");
}